import { ActionTypes } from '../../constants/ActionTypes';
import { IDeleteDraft } from '../../interfaces/DeleteDraft';

export const onDeleteDraft = (action: IDeleteDraft) => {
  return {
    type: ActionTypes.DELETE_DRAFT,
    payload: {
      letterCode: action.letterCode,
      folderCode: action.folderCode,
    },
  };
};

export const onDeleteDraftSuccess = () => {
  return {
    type: ActionTypes.DELETE_DRAFT_SUCCESS,
    payload: true,
  };
};
